import Vue from 'vue';
import Axios from 'axios';
import App from '@/layouts/App.vue';
import router from '@/router';
import store from '@/store';
import configure from '@/config';
import '@/assets/scss/index.scss';

Vue.config.productionTip = false;

/**
 * @method configure
 * @description this function configures all the settings for
 * the app passing as single parameter a JSON with the required
 * vue dependencies, this is the ROOT configuration, each item added
 * to the json will be available throw all the configurations
 */
configure({
    router, // app router history
    store, // app state
    vue: Vue, // main instance for implementations
    axios: Axios, // dependency configuration
    lang: store.getters['lang']
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

let isConsoleEnabled = process.env.VUE_APP_ENABLE_DEV_CONSOLE === 'false';

Vue.config.devtools = isConsoleEnabled;
Vue.config.debug = isConsoleEnabled;
Vue.config.silent = !isConsoleEnabled;